<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="center-form">
        <h2 class="center-align">Account</h2>
        <div class="margin-top-50">
          <div v-if="isInFreeTrial" class="margin-top-25">
            Free trial ending on {{ user.freeTrialEndAt | datetime }}
          </div>
          <h4 class="margin-top-50">Update your account</h4>
          <b-form>
            <b-form-group id="email" label="Email" label-for="email">
              <b-form-input
                id="email"
                v-model="form.email.value"
                :state="form.email.error.state"
                type="email"
                readonly
              ></b-form-input>
              <b-form-invalid-feedback :state="form.email.error.state">
                {{ form.email.error.value }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="name" label="Name" label-for="name">
              <b-form-input
                id="name"
                v-model="form.name.value"
                :state="form.name.error.state"
                type="text"
                required
              ></b-form-input>
              <b-form-invalid-feedback :state="form.name.error.state">
                {{ form.name.error.value }}
              </b-form-invalid-feedback>
            </b-form-group>

            <c-button :onClick="onSave" variant="primary">Update</c-button>
            <br>
            <span class="success">{{ formSuccess }}</span>
            <span class="failure">{{ formFailure }}</span>
          </b-form>
        </div>
        <div class="margin-top-75">
          <h4>Billing</h4>
          <br>
          <c-button :onClick="generateBillingPortalUrl" variant="primary">Manage Billing</c-button>
          <br>
          <span class="success">{{ generateBillingPortalSuccessMessage }}</span>
          <span class="failure">{{ generateBillingPortalFailureMessage }}</span>
        </div>
        <div class="margin-top-75">
          <h4>Danger Zone</h4>
          <br>
          <c-button :onClick="deleteUser" variant="danger">Delete my account</c-button>
          <br>
          <span class="success">{{ deleteUserSuccessMessage }}</span>
          <span class="failure">{{ deleteUserFailureMessage }}</span>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import { onLogin, onLogout } from '../vue-apollo';

  export default {
    name: 'Account',
    components: { CButton },
    props: {

    },
    data() {
      return {
        form: {
          email: {
            value: this.$store.state.loggedUser.email,
            error: {}
          },
          name: {
            value: this.$store.state.loggedUser.name,
            error: {}
          }
        },
        formSuccess: '',
        formFailure: '',
        updateSuccess: '',
        updateFailure: '',
        deleteUserFailureMessage: '',
        deleteUserSuccessMessage: '',
        generateBillingPortalFailureMessage: '',
        generateBillingPortalSuccessMessage: '',
      }
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser
      },
      isInFreeTrial() {
        return new Date(this.$store.state.loggedUser.freeTrialEndAt) > new Date() ? true : false
      }
    },
    methods: {
      async onSave() {
        for (let key in this.form) {
          this.form[key].error = {}
        }
        this.formSuccess = ''
        this.formFailure = ''

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/updateUser.graphql'),
          variables: {
            name: this.form.name.value
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
            if (e.body.details) {
              e.body.details.map(detail => {
                detail.path.map(path => {
                  this.$set(this.form[path], 'error', {state: false, value: detail.message})
                })
              })
            }
          }
        } else {
          this.formSuccess = "Account successfully updated";
          const result = await this.$http.get(process.env.VUE_APP_API_BASE_URL + "/auth");
          if (result && result.body && result.body.user) {
            await onLogin.apply(this, [this.$apollo.provider.defaultClient, result.body.user])
          }
        }
      },
      async deleteUser() {
        if (confirm('Are you sure you want to delete your account? Everything will be deleted. This action is irreversible')) {
          this.deleteUserFailureMessage = ''

          const result = await this.$apollo.mutate({
            client: 'private',
            mutation: require('@/graphql/deleteUser.graphql'),
            fetchPolicy: 'no-cache',
          });

          if (result.errors) {
            const e = result;
            if (e.body) {
              if (e.body.message) {
                this.deleteUserFailureMessage = e.body.message;
              }
            }
          }

          if (result && result.data && result.data.deleteUser && result.data.deleteUser.deleted) {
            await onLogout.apply(this, [this.$apollo.provider.defaultClient])
            this.$router.push({ name: 'Home' });
            this.$router.go(0); // refresh the current page

          } else {
            this.deleteUserFailureMessage = "Error while deleting your account"
          }
        }
      },
      async generateBillingPortalUrl() {
          this.generateBillingPortalFailureMessage = ''

          const result = await this.$apollo.query({
            client: 'private',
            query: require('@/graphql/generateBillingPortalUrl.graphql'),
            fetchPolicy: 'no-cache',
          });

          if (result.errors) {
            const e = result;
            if (e.body) {
              if (e.body.message) {
                this.generateBillingPortalFailureMessage = e.body.message;
              }
            }
          }

          if (result && result.data && result.data.generateBillingPortalUrl && result.data.generateBillingPortalUrl.billingPortalUrl) {
            window.open(result.data.generateBillingPortalUrl.billingPortalUrl, '_blank');
          } else {
            this.generateBillingPortalFailureMessage = "Error while generating the link to access billing portal"
          }
      },
      copyToClipboard(val) {
        this.$copyText(val).then(function () {
          alert('Copied')
        }, function () {
          alert("Couldn't copy to clipboard")
        })
      },
    }
  }
</script>

<style scoped>

</style>
